export default {
  title: 'Erteilte Baugenehmigungen',
  x_axis: 'Jahr',
  y_axis: 'Anzahl der Genehmigungen',
  districts: {
    Alanya: 'Alanya',
    Konyaalti: 'Konyaaltı',
    Kemer: 'Kemer',
    Kepez: 'Kepez',
    Dosemealti: 'Döşemealtı',
    Finike: 'Finike'
  }
}
